<div class="h-full w-full flex flex-col overflow-y-auto scrollbar-transparent">
    <div class="space-y-8">
        <div>
            <h2 class="text-base/7 font-semibold text-primary">What happens next?</h2>
            <p class="text-sm/6 text-secondary">Here's what to expect after you submit your screening brief.</p>
        </div>

        <div class="space-y-6">
            <!-- Step 1 -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex gap-x-4">
                    <div class="shrink-0">
                        <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                            <span class="text-sm font-semibold text-accent/90">1</span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h3 class="text-sm font-semibold text-primary">Brief Posted to Screening KanBan</h3>
                        <p class="mt-2 text-sm text-secondary">
                            Once you've posted the screening brief, it'll go into the Screening KanBan board. If you've not selected creators yet, the brief will go into the "waiting for Creators" column.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex gap-x-4">
                    <div class="shrink-0">
                        <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                            <span class="text-sm font-semibold text-accent/90">2</span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h3 class="text-sm font-semibold text-primary">Brief Refinement</h3>
                        <p class="mt-2 text-sm text-secondary">
                            We will analyse your screening brief and give you an opportunity to fine tune tolerances. You can adjust settings for 100s of parameters. For example, how sensitive are you to foul language? You can set a sensitivity from zero to absolutely not allowed.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex gap-x-4">
                    <div class="shrink-0">
                        <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                            <span class="text-sm font-semibold text-accent/90">3</span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h3 class="text-sm font-semibold text-primary">Content Analysis Begins</h3>
                        <p class="mt-2 text-sm text-secondary">
                            SHOUT will begin analysing and screening content on the accounts of the selected creators.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 4 -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex gap-x-4">
                    <div class="shrink-0">
                        <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                            <span class="text-sm font-semibold text-accent/90">4</span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h3 class="text-sm font-semibold text-primary">Thorough Screening Process</h3>
                        <p class="mt-2 text-sm text-secondary">
                            The screening process takes some time, our screening process is as thorough as your requirements.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 5 -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex gap-x-4">
                    <div class="shrink-0">
                        <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                            <span class="text-sm font-semibold text-accent/90">5</span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h3 class="text-sm font-semibold text-primary">Results & Feedback</h3>
                        <p class="mt-2 text-sm text-secondary">
                            When all accounts have been screened, SHOUT will generate feedback and send you an email. You will be able to see results of the screening process from the Screening KanBan board.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Info Box -->
        <div class="rounded-lg bg-primary/10 dark:bg-primary/10 p-4 outline-1 -outline-offset-1 outline-primary/25 dark:outline-primary/20">
            <div class="flex gap-x-3">
                <div class="shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-accent/90">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 16v-4" />
                        <path d="M12 8h.01" />
                    </svg>
                </div>
                <div class="flex-1">
                    <h3 class="text-sm font-semibold text-primary">Need help?</h3>
                    <p class="mt-1 text-sm text-secondary">
                        You can track the progress of your screening brief at any time from the Screening KanBan board. If you have questions, our support team is here to help.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>